import { render } from "./SQLReader.vue?vue&type=template&id=067bce90"
import script from "./SQLReader.vue?vue&type=script&lang=js"
export * from "./SQLReader.vue?vue&type=script&lang=js"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__